import React, { useEffect } from "react";
import Reserve from "./pages/Reserve";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/NavBar";
import Footer from "./components/Footer";
import DirectBookingCTA from "./components/DirectBookingCTA";
import Facilities from "./pages/Facilities";
import FinePrint from "./pages/FinePrint";
import PropertySurroundings from "./pages/Surroundings";
import Guides from "./pages/Guides";
import GuideDetails from "./pages/GuideDetails";

function ScrollToTopOnRouteChange() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTopOnRouteChange />
      <Navbar />
      <div className="min-h-screen">
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/reserve" element={<Reserve />} />
          <Route path="/facilities" element={<Facilities />} />
          <Route path="/fine-print" element={<FinePrint />} />
          <Route path="/surroundings" element={<PropertySurroundings />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/guides/:slug" element={<GuideDetails />} />
        </Routes>
      </div>
      <DirectBookingCTA />
      <Footer />
    </Router>
  );
}

export default App;
